// SP ドロワーメニュー
// マークアップ: [data-mp-gnav] > [data-mp-drawer-toggle] と [data-mp-drawer]（中に [data-mp-drawer-close]）
// 開閉状態は aria-expanded / aria-hidden で表し、見た目（フェード・stagger）は CSS が担う。

const LOCK_CLASS = 'is-scroll-locked';

function lockScroll(locked) {
  document.documentElement.classList.toggle(LOCK_CLASS, locked);
}

export function setupDrawers() {
  const toggles = [...document.querySelectorAll('[data-mp-drawer-toggle]')];
  const drawers = toggles
    .map((toggle) => {
      const root = toggle.closest('[data-mp-gnav]');
      const drawer = root?.querySelector('[data-mp-drawer]');
      return drawer ? { toggle, drawer } : null;
    })
    .filter(Boolean);

  const setFocusable = (drawer, focusable) => {
    drawer.querySelectorAll('a, button').forEach((el) => {
      el.tabIndex = focusable ? 0 : -1;
    });
  };

  const close = ({ toggle, drawer }, restoreFocus = true) => {
    if (drawer.getAttribute('aria-hidden') === 'false') {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'メニューを開く');
      drawer.setAttribute('aria-hidden', 'true');
      setFocusable(drawer, false);
      lockScroll(false);
      if (restoreFocus) toggle.focus({ preventScroll: true });
    }
  };

  const open = (pair) => {
    drawers.forEach((other) => {
      if (other !== pair) close(other, false);
    });
    const { toggle, drawer } = pair;
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'メニューを閉じる');
    drawer.setAttribute('aria-hidden', 'false');
    setFocusable(drawer, true);
    lockScroll(true);
    requestAnimationFrame(() => {
      // 旧実装と同じく、最初のメニュー項目（ロゴを除く）にフォーカスを移す
      drawer.querySelector('a:not([data-mp-drawer-logo])')?.focus({ preventScroll: true });
    });
  };

  drawers.forEach((pair) => {
    const { toggle, drawer } = pair;
    toggle.addEventListener('click', () => {
      toggle.getAttribute('aria-expanded') === 'true' ? close(pair) : open(pair);
    });
    drawer.querySelector('[data-mp-drawer-close]')?.addEventListener('click', () => close(pair));
    drawer.addEventListener('click', (event) => {
      if (event.target.closest('a')) close(pair, false);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openPair = drawers.find(({ drawer }) => drawer.getAttribute('aria-hidden') === 'false');
    if (openPair) close(openPair);
  });
}
